import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import { __decorate } from "tslib";
import { nanoid } from 'nanoid';
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import tableBaseMixin from './tableBaseMixin';
const NOT_ALLOWED_COLUMN_TYPES = ['selection', 'custom-column'];
let AmTableMixin = class AmTableMixin extends Mixins(tableBaseMixin) {
  constructor() {
    super(...arguments);
    this.forceUpdateKey = '';
    this.iconClass = 'arrow_up';
  }
  get tableColumns() {
    if (!Array.isArray(this.columns)) return [];
    // 将 columns 按照分组聚合
    let tableColumnGroups = {};
    return this.columns.reduce((tableColumns, _column) => {
      if (NOT_ALLOWED_COLUMN_TYPES.includes(_column.type)) return tableColumns;
      const column = this.parseColumn(_column);
      const {
        group
      } = column;
      if (!group) tableColumns.push(column);else {
        let groupColumn = tableColumnGroups[group];
        if (!groupColumn) {
          groupColumn = {
            id: group,
            label: group,
            type: 'group',
            children: []
          };
          tableColumnGroups[group] = groupColumn;
          tableColumns.push(groupColumn);
        }
        groupColumn.children.push(column);
      }
      return tableColumns;
    }, []);
  }
  get tableData() {
    return Array.isArray(this.data) ? this.data : [];
  }
  get enabledCustomColumn() {
    var _this$customColumnPro;
    return !!((_this$customColumnPro = this.customColumnProps) !== null && _this$customColumnPro !== void 0 && _this$customColumnPro.enable);
  }
  get tableCustomColumnProps() {
    var _this$customColumnPro2;
    if ((_this$customColumnPro2 = this.customColumnProps) !== null && _this$customColumnPro2 !== void 0 && _this$customColumnPro2.fixedButton) return {
      ...this.customColumnProps,
      fixedButton: false
    };
    return this.customColumnProps;
  }
  get tableRowHeight() {
    if (!this.rowHeight) return void 0;
    return parseInt(this.rowHeight.replace('px', ''));
  }
  handleTablePropsChange() {
    this.tableHeight = this.height || '';
    this.tableMaxHeight = this.maxHeight || '';
  }
  handleUpdateForceUpdateKey() {
    this.forceUpdateKey = Date.now().toString();
  }
  created() {
    this.tableHeight = this.height;
    this.tableMaxHeight = this.maxHeight;
  }
  parseColumn(_column) {
    const column = {
      ..._column
    };
    if (!column.id) column.id = nanoid();
    if (column.renderHeader) {
      const renderHeader = this.rootVm[column.renderHeader];
      if (typeof renderHeader === 'function') column.renderHeader = renderHeader.bind(this.rootVm);else {
        // 尝试构建 column renderHeader function
        try {
          column.renderHeader = new Function(`return ${column.renderHeader}`).apply(this.rootVm).bind(this.rootVm);
        } catch (error) {
          delete column.renderHeader;
        }
      }
    }
    if (column.render) {
      column.renderType = 'function';
      const renderCell = this.rootVm[column.render];
      if (typeof renderCell === 'function') {
        column.render = renderCell.bind(this.rootVm);
      } else {
        // 尝试构建 column render function
        // 构建失败则渲染为 text
        try {
          column.render = new Function(`return ${column.render}`).apply(this.rootVm).bind(this.rootVm);
        } catch (error) {
          column.renderType = 'text';
          delete column.render;
        }
      }
    } else if (column.renderTemplate) column.renderType = 'custom';
    if (column.formatter) {
      const formatter = this.rootVm[column.formatter];
      if (typeof formatter === 'function') column.formatter = formatter.bind(this.rootVm);else {
        // 尝试构建 column formatter function
        try {
          column.formatter = new Function(`return ${column.formatter}`).apply(this.rootVm).bind(this.rootVm);
        } catch (error) {
          delete column.formatter;
        }
      }
    }
    return column;
  }
  handleCommand(command) {
    this.$emit('drop-selection-click', command);
  }
};
__decorate([Prop(Array)], AmTableMixin.prototype, "columns", void 0);
__decorate([Prop(Array)], AmTableMixin.prototype, "data", void 0);
__decorate([Prop(String)], AmTableMixin.prototype, "height", void 0);
__decorate([Prop(String)], AmTableMixin.prototype, "maxHeight", void 0);
__decorate([Prop(String)], AmTableMixin.prototype, "size", void 0);
__decorate([Prop(Boolean)], AmTableMixin.prototype, "stripe", void 0);
__decorate([Prop(Boolean)], AmTableMixin.prototype, "border", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], AmTableMixin.prototype, "showHeader", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], AmTableMixin.prototype, "fit", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], AmTableMixin.prototype, "isNumber", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], AmTableMixin.prototype, "highlightCurrentRow", void 0);
__decorate([Prop(Boolean)], AmTableMixin.prototype, "virtual", void 0);
__decorate([Prop(Boolean)], AmTableMixin.prototype, "loading", void 0);
__decorate([Prop(Number)], AmTableMixin.prototype, "rowHeight", void 0);
__decorate([Prop(String)], AmTableMixin.prototype, "rowKey", void 0);
__decorate([Prop(Object)], AmTableMixin.prototype, "defaultSort", void 0);
__decorate([Prop(Boolean)], AmTableMixin.prototype, "selection", void 0);
__decorate([Prop(Boolean)], AmTableMixin.prototype, "dropSelection", void 0);
__decorate([Prop(Object)], AmTableMixin.prototype, "customColumnProps", void 0);
__decorate([Prop({
  type: String,
  default: 'dark'
})], AmTableMixin.prototype, "tooltipEffect", void 0);
__decorate([Prop(Function)], AmTableMixin.prototype, "headerCellStyleGetter", void 0);
__decorate([Prop(Function)], AmTableMixin.prototype, "cellStyleGetter", void 0);
__decorate([Prop(Function)], AmTableMixin.prototype, "spanMethod", void 0);
__decorate([Prop(Function)], AmTableMixin.prototype, "selectable", void 0);
__decorate([Prop(Object)], AmTableMixin.prototype, "treeProps", void 0);
__decorate([Prop(Boolean)], AmTableMixin.prototype, "defaultExpandAll", void 0);
__decorate([Prop(Array)], AmTableMixin.prototype, "expandRowKeys", void 0);
__decorate([Watch('height'), Watch('maxHeight')], AmTableMixin.prototype, "handleTablePropsChange", null);
__decorate([Watch('rowKey'), Watch('treeProps'), Watch('defaultExpandAll'), Watch('tableColumns')], AmTableMixin.prototype, "handleUpdateForceUpdateKey", null);
AmTableMixin = __decorate([Component({
  name: 'AmTableMixin'
})], AmTableMixin);
export default AmTableMixin;